export var Languages;
(function (Languages) {
    Languages["en"] = "en";
    Languages["fr"] = "fr";
})(Languages || (Languages = {}));
;
